module.exports = __webpack_public_path__ + "img/yl3069.46df8f57.png";